<template>
  <div class="answer-selection-list">
    <div
      v-for="(answer, index) in answers"
      :id="`answer-${answer.id}`"
      :key="answer.id"
      class="answer-selection-list-item"
      @click="selectAnswer(answer.id)"
    >
      <icon-button
        class="icon-button"
        :class="{
          disabled: disableSelect,
          correct: answer.correct,
          selected: selected.includes(answer.id)
        }"
        :label-html="answer.content || answer.text"
      >
        <template #icon>
          <radio-button
            :answered="true"
            :selected="selected.includes(answer.id)"
            :correct="answer.correct"
            :use-answer-labels="useAnswerLabels"
            :index="index"
            :is-sata="isSata"
            size="small"
            class="icon"
          ></radio-button>
        </template>
        <template #metadata>
          <span
            v-if="showMetadata && showFlashcardMetadata"
            class="answer-percentage"
          >({{ answerPercentage(answer.id) }}%)</span>
        </template>
      </icon-button>
    </div>
  </div>
</template>

<script>
import IconButton from '@/components/flashcards-v2/fragments/IconButton';
import RadioButton from '@/components/flashcards-v2/fragments/RadioButton';
import FlashcardMetadataMixin from '@/mixins/flashcardMetadata.js';

export default {
  components: { IconButton, RadioButton },
  mixins: [FlashcardMetadataMixin],
  props: {
    answers: {
      type: Array,
      default: () => [],
    },
    flashcard: {
      type: Object,
      default: () => ({}),
    },
    selected: {
      type: Array,
      default: () => [],
    },
    showMetadata: {
      type: Boolean,
      default: true,
    },
    disableSelect: {
      type: Boolean,
      default: true,
    },
    isSata: {
      type: Boolean,
      default: false,
    },
    suppressAnswerLabels: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['select-answer'],
  computed: {
    useAnswerLabels() {
      return !this.suppressAnswerLabels && this.$store.getters['app/answerLabelsEnabled'];
    },
  },
  methods: {
    selectAnswer(answerId) {
      if (this.disableSelect) {
        return;
      }
      this.$emit('select-answer', answerId);
    },
  },
};
</script>

<style lang="scss" scoped>
.answer-selection-list {
  display: flex;
  flex-direction: column;
  gap: rem-calc(12);
}

.answer-selection-list-item {
  cursor: pointer;

  .icon {
    margin-top: 3px;
  }

  .answer-percentage {
    font-size: rem-calc(12);
    font-weight: 600;
    color: rgba(105, 117, 134, 1);
  }

  .icon-button {
    &.selected {
      background: #FEF3F2;
      border: 1px solid #FDA29B;

      &.correct {
        background: #ECFDF3;
        border: 1px solid #ABEFC6;
      }
    }
  }
}

.disabled {
  cursor: default;
}
</style>
